import CancelIcon from '@mui/icons-material/Cancel'
import { Box, Chip } from '@mui/material'
import { useImpersonation } from '../../io/context/ImpersonationContext'
import EntityLink from '../data/EntityLink'

const ImpersonationChip = () => {
  const { impersonatedUserId, isImpersonating, stopImpersonation } = useImpersonation()
  if (!isImpersonating || !impersonatedUserId) return null

  return (
    <Chip
      data-testid="impersonation-chip"
      color="warning"
      label={
        <Box component="span" sx={{ display: 'inline-flex', gap: 0.5 }}>
          <span>Impersonating</span>
          <EntityLink entityId={impersonatedUserId} showTooltip={false} />
        </Box>
      }
      onDelete={stopImpersonation}
      deleteIcon={<CancelIcon data-testid="impersonation-chip-stop" />}
      sx={{ mr: 1, color: 'warning.contrastText' }}
    />
  )
}

export default ImpersonationChip
